import { Modifiers } from "popper.js";

interface Category {
   title: string;
   items: {
      title: string;
      href: string;
   }[];
}

export const MODIFIERS: Modifiers = {
   offset: {
      enabled: true,
      offset: "-50%p + 50%r",
   },
   preventOverflow: {
      enabled: true,
      padding: 8,
      boundariesElement: "window",
   },
   flip: {
      enabled: false,
   },
};

export const CATEGORIES: Category[][] = [
   [
      {
         title: "STRATEGY",
         items: [
            {
               title: "Workplace Strategist",
               href: "/workplace-strategist",
            },
         ]
      },
   ],
   [
      {
         title: "OPERATIONS",
         items: [
            { title: "Transaction Manager", href: "/transaction-manager" },
            { title: "License Administrator", href: "/license-administrator" },
            { title: "Workplace Manager", href: "/workplace-manager" },          
         ],
      },
   ],
   [
      {
         title: "ACCESS",
         items: [
            { title: "On-Demand Workspace", href: "/flexible-office-space" },
            {
               title: "Private Office Space",
               href: "/dedicated-office-space",
            },
         ],
      },
   ],
   [
      {
         title: "INTEGRATIONS",
         items: [            
            { title: "HRIS User Provisioning", href: "/integrations#hris" },
            { title: "IWMS Integration", href: "/integrations#iwms" },
            { title: "SSO & SCIM", href: "/integrations#sso" },
            { title: "Communication Tools", href: "/integrations#communication" },
            { title: "BI & Reporting", href: "/integrations#bi" },
         ],
      },
   ],
];
